/**
 * Client ads environment, read EXPLICITLY.
 *
 * Vite statically replaces `import.meta.env.VITE_FOO` in the build: passing the
 * whole object to a generic function would work in dev and arrive empty (or
 * incomplete) in the production bundle. That is why each key is named here one
 * by one — the same reason `runtime-config.ts` does not spread the env.
 *
 * RUNTIME config (`window.__APP_CONFIG__`, injected by the container) is also
 * accepted to honor build-once → promote: turning ads on in an environment
 * must not require a rebuild.
 */

interface AdsRuntimeConfig {
  ADS_ENABLED?: string;
  ADS_NETWORK?: string;
  ADS_TIER?: string;
  ADS_CHILD_DIRECTED?: string;
  ADS_MAX_CONTENT_RATING?: string;
  ADS_CONTEXTUAL_ONLY?: string;
  ADS_CLIENT_ID?: string;
}

function runtime(): AdsRuntimeConfig {
  return (
    (globalThis as typeof globalThis & { __APP_CONFIG__?: AdsRuntimeConfig }).__APP_CONFIG__ ?? {}
  );
}

/** Snapshot of the ads environment for `resolveAdsConfig`. */
export function adsEnv(): Record<string, string | undefined> {
  const r = runtime();
  return {
    VITE_ADS_ENABLED: r.ADS_ENABLED ?? import.meta.env.VITE_ADS_ENABLED,
    VITE_ADS_NETWORK: r.ADS_NETWORK ?? import.meta.env.VITE_ADS_NETWORK,
    VITE_ADS_TIER: r.ADS_TIER ?? import.meta.env.VITE_ADS_TIER,
    VITE_ADS_CHILD_DIRECTED: r.ADS_CHILD_DIRECTED ?? import.meta.env.VITE_ADS_CHILD_DIRECTED,
    VITE_ADS_MAX_CONTENT_RATING:
      r.ADS_MAX_CONTENT_RATING ?? import.meta.env.VITE_ADS_MAX_CONTENT_RATING,
    // It exists so the clamp has something to reject: setting it to `false` does
    // NOT serve personalized ads (the financial floor turns it back to `true`).
    VITE_ADS_CONTEXTUAL_ONLY: r.ADS_CONTEXTUAL_ONLY ?? import.meta.env.VITE_ADS_CONTEXTUAL_ONLY,
    VITE_ADS_CLIENT_ID: r.ADS_CLIENT_ID ?? import.meta.env.VITE_ADS_CLIENT_ID,
  };
}
